module.exports = require("./fr-SY.js");